import React from 'react';
import { useMsal } from '@azure/msal-react';
import './LoggedOut.css';

const LoggedOut = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect({
      redirectStartPage: `${window.location.origin}/`
    });
  };

  return (
    <div className="dashboard-ecommerce">
      <div className="container-fluid dashboard-content">
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="widget">
              <div className="card-header">You are logged out</div>
              <hr className="hr" />
              <div className="logged-out-card">
                <div className="logged-out-content">
                  <h5 className="logged-out-title">Session ended successfully</h5>
                  <p className="logged-out-message">
                    Your LillyNow Ancillary Portal session has been closed. Use the button below to sign in again.
                  </p>
                  <button
                    type="button"
                    onClick={handleLogin}
                    className="logged-out-button"
                  >
                    Sign In
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoggedOut;
